/**
* セレクトエリアのコンストラクタ
* @constructor
* @param {selector} el - セレクタ
*/
module.exports = FormSelect = function(el){
  this.element = $(el);
  this.target = $('.js-select-other');
  this.event();
  this.showOther(this.element);
};

/**
* イベント
*/
FormSelect.prototype.event = function(){
  var self = this;
  this.element.on('change',function(e){
    self.showOther($(this));
  });
};

/**
* その他を表示
* @param {selector} el - セレクタ
*/
FormSelect.prototype.showOther = function(el){
  var self = this;
  var selected = el.find('option:selected').attr('id');
  if(selected === 'other'){
    this.target.removeClass('is-hidden');
  }else{
    this.target.addClass('is-hidden');
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/_modules/formSelect.js
// module id = 4
// module chunks = 0